import { getCustomFilterList } from "../components/NewFilter/customFilterList";

type TFilterKey = 'version' | 'region' | 'channel' | 'system' | 'zone' | 'language' | 'bundle' | 'category' | 'ua_network' | 'ad_format' | string;
interface IFilterValue {
  version?: unknown;
  region?: unknown;
  channel?: unknown;
  system?: unknown;
  zone?: unknown;
  language?: unknown;
  bundle?: unknown;
  category?: unknown;
  ua_network?: unknown;
  ad_format?: unknown;
  custom_filters?: {
    key: string;
    filter_list: string[];
  }[];
  [key: string]: unknown;
}

const accumulationMapByFilterKey: Record<TFilterKey, string[]> = {
  version: ['by_version'],
  region: ['by_region', 'by_country'],
  channel: ['by_channel'],
  system: ['by_system'],
  zone: ['by_zone'],
  language: ['by_language'],
  bundle: ['by_bundle'],
  category: ['by_category','by_product'],
  ua_network: ['by_ua_network'],
  ad_format: ['by_ad_format'],
  // 实时预览筛选器value格式生成分维度
  version_list: ['by_version'],
  market_list: ['by_region', 'by_country'],
  region_list: ['by_region', 'by_country'],
  channel_list: ['by_channel'],
  os_list: ['by_system'],
  zone_list: ['by_zone'],
  lang_list: ['by_language'],
  bundle_list: ['by_bundle'],
  category_list: ['by_category','by_product'],
  ua_network_list: ['by_ua_network'],
  ad_format_list: ['by_ad_format'],
};

export const getAccumulationListFromFilterValue = (filterValue: IFilterValue): string[] => {
  const accumulationList: string[] = [];

  for (const [filterKey, accumulationValues] of Object.entries(accumulationMapByFilterKey)) {
    if (filterValue?.[filterKey] || filterValue?.custom_filters?.some((item: any) => item?.key === filterKey)) {
      accumulationList.push(...accumulationValues);
    }
  }

  return accumulationList;
};

export const getAccumulation = (accumulationList: string[], dataBy: TFilterKey): Record<string, any> => {
  // 自定义筛选器的 key 映射
  const customAccumulationKeys = getCustomFilterList();
  // 分离自定义筛选器和标准筛选器
  const customAccumulationList: string[] = [];
  const standardAccumulationList: string[] = [];
  
  accumulationList.forEach((item) => {
    if (customAccumulationKeys.includes(item?.replace('by_', ''))) {
      customAccumulationList.push(item);
    } else {
      standardAccumulationList.push(item);
    }
  });
  
  // 构建标准 accumulation 对象
  const initialAccumulation: Record<string, boolean> = {};
  const accumulation: Record<string, any> = standardAccumulationList.reduce((acc, accumulationItem) => {
    acc[accumulationItem] = accumulationItem.includes(dataBy);
    return acc;
  }, initialAccumulation);
  // 构建 custom_accumulation 数组
  if (customAccumulationList.length > 0) {
    accumulation.custom_accumulation = customAccumulationList.map((item) => {
      const key = item.replace('by_', '');
      return {
        key,
        is_accumulation: item.includes(dataBy),
      };
    });
  }
  
  return accumulation;
};